module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino-closing-mono-light-f55cb8d251a9ec9e8253bd0b0e30f8ff.svg";